// extracted by mini-css-extract-plugin
module.exports = {"LabelSubText":"createIndebtedness_LabelSubText__2QoU5","errorMessage":"createIndebtedness_errorMessage__3X0y1","Title":"createIndebtedness_Title__cbEaq"};